export const CANCELAR_ESCOPO_FORM_ID = "cancelar-escopo-macro-form";

export const CANCELAR_ESCOPO_TITLE = "Cancelar Escopo macro";
/** Lista do escopo (Figma 16321:432933). */
export const ITEM_ESCOPO = "Escopo macro";
export const ITEM_TIPO_OBRA = "Tipo de Obra";
export const ITEM_CENTRO_CUSTO = "Centro de custo";
export const ITEM_PROJECAO = "Projeção";
export const PROJECAO_PENDENTE = "Pendente";
export const CANCELAR_LABEL = "Cancelar";
export const CONFIRMAR_LABEL = "Solicitar cancelamento";
/** Figma 16321:433203: em FEL-0 o cancelamento é efetivado na hora. */
export const CONFIRMAR_EFETIVAR_LABEL = "Cancelar Escopo macro";
export const CARREGANDO_LABEL = "Carregando dados do escopo macro...";

export const CONFIRMACAO_MESSAGE = "Tem certeza de que deseja cancelar este escopo macro?";

export const DESTINO_DEVOLVER_LABEL = "Devolver valor projetado";
export const DESTINO_DEVOLVER_AJUDA = "O valor projetado deste escopo macro é devolvido à empresa.";
export const DESTINO_MANTER_LABEL = "Manter na Obra";
export const DESTINO_MANTER_AJUDA = (tipo: string) =>
  `Depois da aprovação, o escopo fica cancelado e o valor continua no ${tipo} até ser destinado aos outros escopos macro dele.`;
/** Figma 16321:434283: do FEL-4 em diante o valor vai para a contingência. */
export const DESTINO_MANTER_CONTINGENCIA_AJUDA = "O valor vai para a contingência da Obra.";

/** Figma 16321:433263 (FEL-0, sem destino). */
export const IMPACTO_FEL_ZERO =
  "A projeção de Serviços e Materiais deste escopo macro sai do total e da mensalização da Obra.";
/** Figma 16312:675164: antes de escolher o destino. */
export const IMPACTO_NEUTRO =
  "Depois da aprovação, este escopo macro é cancelado. O efeito no total da Obra depende do destino do valor projetado.";
/** Figma 17191:491750. */
export const IMPACTO_DEVOLVER =
  "Depois da aprovação, a projeção de Serviços e Materiais deste escopo macro sai do total e da mensalização da Obra.";
/** Figma 16321:432933 (FEL-1 a FEL-3). */
export const IMPACTO_MANTER =
  "Depois da aprovação, este escopo macro fica como Cancelado Aguardando Destino do Saldo. O valor projetado continua no total e na mensalização da Obra até ser redistribuído.";
/** Figma 16321:434283 (FEL-4 em diante). */
export const IMPACTO_MANTER_CONTINGENCIA =
  "Depois da aprovação, o valor projetado deste escopo macro vai para a contingência da Obra.";
/** Figma 16321:434013: sem projeção não há destino nem aviso de impacto. */
const AVISO_SEM_PROJECAO_BASE = "Este escopo macro ainda não tem projeção.";
export const AVISO_SEM_PROJECAO = `${AVISO_SEM_PROJECAO_BASE} Depois da aprovação, a pendência de projeção dele é encerrada.`;
/** FEL-0 efetiva na hora: sem a frase da aprovação. */
export const AVISO_SEM_PROJECAO_FEL_ZERO = `${AVISO_SEM_PROJECAO_BASE} A pendência de projeção dele é encerrada.`;
/** Figma 16321:434598. */
const ULTIMO_ESCOPO_BASE = (tipo: string) => `Este é o último escopo macro do ${tipo}.`;
const ULTIMO_ESCOPO_EFEITO =
  'fica sem escopo macro e passa a ter a pendência "Tipo de Obra sem Escopo Macro".';
export const ULTIMO_ESCOPO_MESSAGE = (tipo: string) =>
  `${ULTIMO_ESCOPO_BASE(tipo)} Depois da aprovação, o Tipo de Obra ${ULTIMO_ESCOPO_EFEITO}`;
export const ULTIMO_ESCOPO_MESSAGE_FEL_ZERO = (tipo: string) =>
  `${ULTIMO_ESCOPO_BASE(tipo)} O Tipo de Obra ${ULTIMO_ESCOPO_EFEITO}`;

export const CANCELADO_MESSAGE = "Escopo macro cancelado com sucesso.";
export const ENVIADO_PARA_APROVACAO =
  "Solicitação de cancelamento enviada para aprovação. O Escopo Macro permanece ativo até a conclusão da análise.";
